import { useGetQuery, type UseGetQueryOptions } from "@src/appV2/api";
import { environmentConfig } from "@src/appV2/environment";
import { APP_V2_APP_EVENTS } from "@src/appV2/lib/analytics";
import { minutesToMilliseconds } from "date-fns";
import { z } from "zod";

import { facilityPhotoSchema } from "../types";

export function getWorkplacePhotosUrl(workplaceId: string): string {
  return `${environmentConfig.REACT_APP_BASE_API_URL}/facilityprofile/photos/${workplaceId}`;
}

const workplacePhotosResponseSchema = z.object({
  photosList: z.array(facilityPhotoSchema),
});

export type WorkplacePhotosResponse = z.infer<typeof workplacePhotosResponseSchema>;

export interface WorkplacePhotosParams {
  workplaceId: string;
}

export function useWorkplacePhotos(
  queryParams: WorkplacePhotosParams,
  options: UseGetQueryOptions<WorkplacePhotosResponse> = {}
) {
  const { workplaceId } = queryParams;
  return useGetQuery({
    url: getWorkplacePhotosUrl(workplaceId),
    responseSchema: workplacePhotosResponseSchema,
    meta: {
      logErrorMessage: APP_V2_APP_EVENTS.GET_FACILITY_PHOTOS_FAILURE,
    },
    // Workplace photos rarely change, so we cache them for 60 minutes to prevent unnecessary refetches
    // and reduce re-renders across components using this data
    staleTime: minutesToMilliseconds(60),
    ...options,
  });
}
